import React from 'react';
import { Box } from '@material-ui/core';

/**
 * ImageDropzone Block Component
 * Schematic representation of an image upload area
 */
const ImageDropzone = ({ hidden, ...props }) => {
  if (hidden) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height={120}
      bgcolor="#f9f9f9"
      border="2px dashed #e0e0e0"
      borderRadius={4}
      padding={2}
      boxSizing="border-box"
      {...props}
    >
      {/* Icon Placeholder */}
      <Box
        width={32}
        height={32}
        borderRadius="50%"
        bgcolor="#eeeeee"
        border="2px solid #e0e0e0"
        marginBottom={1.5}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box width={12} height={12} bgcolor="#bdbdbd" borderRadius={2} />
      </Box>

      {/* Text Lines */}
      <Box width="60%" height={8} bgcolor="#e0e0e0" borderRadius={4} marginBottom={1} />
      <Box width="40%" height={6} bgcolor="#eeeeee" borderRadius={3} />
    </Box>
  );
};

export default ImageDropzone;
